import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Account API - Base definition
 *
 * This is the base API slice for the Account service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see accountEndpoints.ts - Account queries and write-off candidates
 */
export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.accounts),
  tagTypes: ['Account', 'AccountList', 'WriteOffCandidates'],
  endpoints: () => ({}),
});
